import { Canvas } from "fabric";

class CanvasUtils {
  static updateCanvasCursor(canvas: Canvas, cursor: string): void {
    if (!canvas) return;

    canvas.defaultCursor = cursor;
    canvas.hoverCursor = cursor;

    if (canvas.upperCanvasEl) {
      canvas.upperCanvasEl.style.cursor = cursor;
    }
  }

  static getBrushSize(canvas: Canvas): number | undefined {
    if (!canvas) return undefined;

    const canvasWidth = canvas.getWidth();
    const canvasHeight = canvas.getHeight();

    return Math.max(2, Math.min(12, Math.min(canvasWidth, canvasHeight) / 200));
  }

  static getFontSize(canvas: Canvas): number | undefined {
    if (!canvas) return undefined;

    const canvasWidth = canvas.getWidth();
    const canvasHeight = canvas.getHeight();

    return Math.max(
      14,
      Math.min(150, Math.min(canvasWidth, canvasHeight) / 13)
    );
  }

  static clearCanvas(canvas: Canvas): void {
    if (!canvas) return;

    canvas.clear();

    canvas.renderAll();
  }

  static setObjectsSelectable(canvas: Canvas, selectable: boolean): void {
    if (!canvas) return;

    canvas.selection = selectable;
    canvas.forEachObject((obj) => {
      obj.selectable = selectable;
      obj.evented = selectable;
    });

    canvas.renderAll();
  }
}

export default CanvasUtils;
